export default __webpack_public_path__ + "static/media/service-bg.16c84393.png";